export default __webpack_public_path__ + "static/media/service-5_large.efe07ee5.png";